import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "upload-wrap" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h4", null, "List of files", -1)
const _hoisted_3 = { class: "el-upload-list__item-info" }
const _hoisted_4 = { class: "el-upload-list__item-name" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = ["onClick"]

import { onMounted, reactive } from 'vue';

import type { UploadFile, UploadProps } from 'element-plus';
import { ElMessage, ElMessageBox } from 'element-plus';
import { FileDetailsTypes, FileListTypes, UploadRequestOptionsTypes } from '@/types/FileListTypes';
import { deleteDocument, getDocuments, uploadDocument } from '@/api/documentRequests';
import toBase64 from '@/helpers/toBase64';
import { DocsTypes } from '@/types/DocsTypes';
import { getFileName } from '@/helpers/utils';
import { Delete, Download } from '@element-plus/icons-vue';
import { saveAs } from 'file-saver';


export default /*#__PURE__*/_defineComponent({
  __name: 'FilesList',
  setup(__props) {


const fileList = reactive<FileListTypes>({
  data: [],
  isLoaded: true,
});

const handleHttpRequest = async (options: UploadRequestOptionsTypes) => {
  const { file } = options;
  const base64File = await toBase64(file);

  const title = getFileName(file.name);

  const payload = {
    title,
    file: {
      mime: file.type,
      data: base64File as string,
    },
  };
  uploadDocument(payload).then(({ fileName }) => {
    ElMessage({ message: `The file ${fileName} was uploaded`, type: 'success', showClose: true });
  }).catch((e) => {
    ElMessage({
      message: e.response.data, type: 'error', duration: 6000, showClose: true,
    });

    fileList.data = fileList.data.filter((item) => item.uid !== file.uid);
  });
};

onMounted(async () => {
  const data = await getDocuments();
  if (data) {
    fileList.isLoaded = false;
    fileList.data = data.map(({
      title, size, id, url,
    }) => ({
      name: title, size, id, url,
    }));
  }
});

const handleDownload = ({ name, url }: UploadFile) => {
  if (url) {
    saveAs(url, name);
  }
};

const beforeRemove = (uploadFile: FileDetailsTypes) => ElMessageBox.confirm(
  `Delete file ${uploadFile.name}?`,
).then(
  () => true,
  () => false,
);

const handleRemove = async (file: FileDetailsTypes) => {
  const { id, uid } = file;
  const isConfirm = await beforeRemove(file);
  const data = await deleteDocument(id);

  if (data && isConfirm) {
    fileList.data = fileList.data.filter((item) => item.uid !== uid);
  }
};

const handlePreview: UploadProps['onPreview'] = ({ url }) => window.open(url);
const handleOnSuccess: UploadProps['onSuccess'] = (response: DocsTypes, uploadFile: UploadFile) => {
  if (!response) {
    return null;
  }

  const { uid } = uploadFile;
  const { id, url } = response;

  fileList.data = fileList.data.map((item) => (item.uid === uid ? {
    ...item,
    url,
    id,
  }
    : item));

  return fileList.data;
};


return (_ctx: any,_cache: any) => {
  const _component_el_alert = _resolveComponent("el-alert")!
  const _component_el_skeleton = _resolveComponent("el-skeleton")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_upload = _resolveComponent("el-upload")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_alert, {
      title: "Only pdf or pptx files",
      type: "info",
      closable: false,
      "show-icon": ""
    }),
    _createVNode(_component_el_skeleton, {
      rows: 5,
      animated: "",
      variant: "p",
      loading: fileList.isLoaded
    }, null, 8, ["loading"]),
    _createVNode(_component_el_upload, {
      "file-list": fileList.data,
      "onUpdate:fileList": _cache[0] || (_cache[0] = ($event: any) => ((fileList.data) = $event)),
      "http-request": handleHttpRequest,
      multiple: "",
      accept: ".pdf,.PDF,.pptx"
    }, {
      tip: _withCtx(() => [
        _hoisted_2
      ]),
      file: _withCtx(({ file }) => [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_el_icon, {
              size: "20",
              title: "Download",
              onClick: ($event: any) => (handleDownload(file))
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(Download))
              ]),
              _: 2
            }, 1032, ["onClick"]),
            _createElementVNode("div", {
              class: "el-upload-list__item-file-name",
              onClick: ($event: any) => (handlePreview(file))
            }, _toDisplayString(file.name), 9, _hoisted_5)
          ]),
          _createElementVNode("div", {
            class: "el-upload-list__item-delete",
            onClick: ($event: any) => (handleRemove(file))
          }, [
            _createVNode(_component_el_icon, {
              title: "Delete",
              size: "16",
              color: "#F56C6C"
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(Delete))
              ]),
              _: 1
            })
          ], 8, _hoisted_6)
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_button, { type: "primary" }, {
          default: _withCtx(() => [
            _createTextVNode("Click to upload")
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["file-list"])
  ]))
}
}

})